import { LockOutlined } from '@ant-design/icons';
import { ConfigProvider, Empty, Flex, Skeleton, Space, Table, theme } from 'antd';
import React from 'react';
import { ContestParticipant, RootState, selectUserLoggedIn } from '../../modules';
import { useSelector } from 'react-redux';

interface Props {
    participants: ContestParticipant[];
    currentPage: number;
    pageSize: number;
    columns: any;
    handleTableChange: (pagination: { current: number; pageSize: number }) => void;
    maxParticipants: number;
}
const ParticipantsTable: React.FC<Props> = ({ participants, columns, currentPage, pageSize, handleTableChange, maxParticipants }) => {
    const isLogin = useSelector((state: RootState) => selectUserLoggedIn(state));
    const tableTitle = maxParticipants > 0 ? `${participants.length}/${maxParticipants} participants` : 'Participants';
    return (
        <Flex vertical gap="0.5rem" className="participants-container">
            <div className="participants-wrapper">
                <div className="participants-headline">{tableTitle}</div>
                {isLogin ? (
                    participants.length === 0 ? (
                        <div className="participants-empty">
                            <Empty description="No participants found." />
                        </div>
                    ) : (
                        <>
                            <div className="participants-summary" style={{ marginBottom: 12, textAlign: 'right' }}>
                                <span className="participants-count">
                                    Total: {participants.length.toLocaleString()}
                                </span>
                                {" | "}
                                Showing <span className="participants-count">{pageSize}</span> per page
                            </div>
                            <div className="participants-table">
                                <Table
                                    rowKey={(record: ContestParticipant) => `${record.contestId}-${record.uid}`}
                                    columns={columns}
                                    dataSource={participants}
                                    bordered
                                    size="small"
                                    pagination={{
                                        current: currentPage,
                                        pageSize,
                                        total: participants.length,
                                        onChange: (page, pageSize) => handleTableChange({ current: page, pageSize: pageSize ?? 50 }),
                                        showSizeChanger: true,
                                        showTotal: (total) => (
                                            <span className="participants-pagination-total">Total {total} {total === 1 ? 'user' : 'users'}</span>
                                        ),
                                    }}
                                />
                            </div>
                        </>
                    )
                ) : (
                    <div style={{
                        textAlign: 'center',
                        padding: '48px 0',
                        background: 'var(--body-background-color)',
                        borderRadius: '8px',
                        border: '1px dashed var(--border-color-base)'
                    }}>
                        <LockOutlined style={{ fontSize: '32px', color: 'var(--text-color-secondary)' }} />
                        <p style={{ marginTop: '16px', fontSize: '16px', color: 'var(--text-color-secondary)' }}>
                            Please <a href="/signin">sign in</a> to view the list of participants.
                        </p>
                    </div>
                )}
            </div>
        </Flex>
    );
};

export default ParticipantsTable;
